import { objectOf, maybe } from "@altostra/type-validations";
import { string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdTemplatedPreviewResult = objectOf({
  templated_preview: any,
  user_id: maybe(string),
});
